import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output, Pipe, PipeTransform } from '@angular/core';
import { CalendarDay } from 'app/core/store/calendar/common/calendar.interface';
import { OrderDetail } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { Template } from 'app/core/store/template/template.interface';

@Component({
  selector: 'app-calendar-draggable-templates',
  templateUrl: './calendar-draggable-templates.component.html',
  styleUrls: ['./calendar-draggable-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class CalendarDraggableTemplatesComponent implements AfterViewInit {
  @Input() type: 'ORDERS' | 'RELOCATIONS';
  @Input() templates: Template[];
  @Input() editing: number = null;
  @Input() deleting: boolean = false;
  @Input() selectedTemplate: OrderDetail;
  @Input() deliveryDaysRequesting: boolean = false;
  @Input() authorization: AuthorizationMatrix;
  @Input() showBack: boolean = false;
  @Input() canViewTemplate: boolean = false;
  @Input() isSuperUser: boolean = false;
  @Input() selectedCustomer = null;

  @Output() goBack = new EventEmitter();
  @Output() createTemplate = new EventEmitter();
  @Output() deleteTemplate = new EventEmitter<number>();
  @Output() selectTemplate = new EventEmitter();
  @Output() editTemplate = new EventEmitter<number>();
  @Output() createOrder = new EventEmitter<{ templateId: number, date: string }>();

  height: number = 0;
  templateSearch: string = '';

  constructor(private cd: ChangeDetectorRef) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resize(event.currentTarget.innerHeight);
  }

  ngAfterViewInit() {
    this.resize(window.innerHeight);
    this.cd.detectChanges();
  }

  resize(innerHeight) {
    if (this.isSuperUser) {
      this.height = innerHeight - 740;
    } else {
      if (this.showBack) {
        this.height = innerHeight - 596;
      } else {
        this.height = innerHeight - 600;
      }
    }
  }

  dropped(event: CdkDragDrop<CalendarDay, any, Template>) {
    if (!event.container.disabled) {
      this.createOrder.emit({ templateId: event.item.data.id, date: event.container.data.date.format('YYYY-MM-DD') });
    }
  }
}

@Pipe({ name: 'templateNameFilter' })
export class TemplateNameFilterPipe implements PipeTransform {
  transform(templates: Template[], searchText: string): Template[] {
    if (!templates) return [];

    const loweredSearchText = searchText?.toLowerCase();
    const filtered = loweredSearchText
      ? templates.filter(t => t.name?.toLowerCase().includes(loweredSearchText))
      : templates;

    return [...filtered].sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
  }
}
